module.exports = __webpack_public_path__ + "img/20210521114604725e0k.cbca3476.png";